var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStripes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148 18",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-stripes_svg__clip0)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.27 0L0 4.46V3.37L1.72 0h.55zM10.75 0L1.94 17.29h-.55L10.2 0h.55zM19.23 0l-8.81 17.29h-.55L18.68 0h.55zM27.71 0L18.9 17.29h-.55L27.16 0h.55zM36.19 0l-8.81 17.29h-.55L35.64 0h.55zM44.67 0l-8.81 17.29h-.56L44.11 0h.56zM53.15 0l-8.81 17.29h-.56L52.59 0h.56zM61.63 0l-8.81 17.29h-.56L61.07 0h.56zM70.11 0L61.3 17.29h-.56L69.55 0h.56zM78.59 0l-8.81 17.29h-.56L78.03 0h.56zM87.07 0l-8.81 17.29h-.56L86.51 0h.56zM95.55 0l-8.81 17.29h-.56L94.99 0h.56zM104.03 0l-8.81 17.29h-.56L103.47 0h.56zM112.51 0l-8.81 17.29h-.56L111.95 0h.56zM120.98 0l-8.8 17.29h-.56L120.43 0h.55zM129.46 0l-8.8 17.29h-.56L128.91 0h.55zM137.94 0l-8.81 17.29h-.55L137.39 0h.55zM146.42 0l-8.81 17.29h-.55L145.87 0h.55zM147.66 13.13v1.08l-1.57 3.08h-.55l2.12-4.16z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-stripes_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h147.66v17.29H0z"
  })))));
}
export default SvgIconStripes;